import { MonitorReport } from 'quality/quality_report';
import Env from 'common/env';
let exportData = {};

if(!Env.isCSR) {
    var _processError = function (errObj) {
        let newErrObj = errObj
        try {
            if (errObj.stack) {
                var url = errObj.stack.match("http://[^\n]+");
                url = url ? url[0] : "";
                var rowCols = url.match(":([0-9]+):([0-9]+)");
                if (!rowCols) {
                    rowCols = [0, 0, 0];
                }
    
                var stack = _processStackMsg(errObj);
                newErrObj = JSON.stringify({
                    msg: stack,
                    rowNum: rowCols[1],
                    colNum: rowCols[2],
                    target: url.replace(rowCols[0], "")
                });
            } else {
                // 只有message而没有stack的错误，不确定是否存在这类错误，加上保险。
                // 由于 JSON.stringify 对于 Error 对象是无效的，所以要明确检测 message
                if (errObj.message) {
                    newErrObj = errObj.message
                }
            }
        } catch (err) {
        }
        if (typeof newErrObj !== 'string') {
            newErrObj = JSON.stringify(newErrObj)
        }
        return newErrObj
    };
    
    var _processStackMsg = function (error) {
        var stack = error.stack.replace(/\n/gi, "").split(/\bat\b/).slice(0, 2).join("@").replace(/\?[^:]+/gi, "");
        var msg = error.toString();
        if (stack.indexOf(msg) < 0) {
            stack = msg + "@" + stack;
        }
        return stack;
    };
    
    var _shortError = function(error) {
        if(typeof error == 'string') {
            return error.split('\n')[0]
        }else if(typeof error == 'object') {
            return error.message
        }
    
        return '';
    }
    
    function convertToUpperCase(str = ''){
        var arr =  str.split("-");  
        for(var i = 0,len = arr.length;i < len; i++){
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substring(1)
        }
        return arr.join('')
    }
    
    let GlobalMonitorTimer = null;
    let GlobalMonitorList = [];
    let GlobalMonitorError = new MonitorReport('wxgame-components');
    
    exportData = { 
        report (err, vm, info) {
            try {
                let error = typeof err === 'string' ? err : _processError(err);
                let shortErr = _shortError(err);
    
                if(vm && vm.$vnode && vm.$vnode.componentOptions && vm.$vnode.componentOptions.tag) {
                    let tag = convertToUpperCase(vm.$vnode.componentOptions.tag);
                    let version = window.__COMP_BUILD_VERSION__ && window.__COMP_BUILD_VERSION__.list[tag] || '0';
    
                    GlobalMonitorList.push({
                        tag: tag,
                        version: version,
                        err: error,
                        info: info || '',
                        short: shortErr || error
                    })
    
                    if(GlobalMonitorTimer) {
                        clearTimeout(GlobalMonitorTimer)
                        GlobalMonitorTimer = null;
                    }
                    GlobalMonitorTimer = setTimeout(() => {
                        let list = [];
                        for(let item of GlobalMonitorList) {
                            list.push({
                                id: 173,
                                key1: item.tag,
                                key2: version,
                                key3: window.__COMP_BUILD_VERSION__ && window.__COMP_BUILD_VERSION__.version,
                                key4: item.info,
                                key5: item.short,
                                key6: item.err
                            })
                        }
                        GlobalMonitorList = [];
                        if(list.length) {
                            GlobalMonitorError.send(list)
                        }
                    }, 250)
                }
            }catch(e) {
            }
        }
    }
}
export default exportData;

export const {
    report
} = exportData;